module.exports = __webpack_public_path__ + "static/media/r_dot_17.d7585b50.png";